import React, { useState, useEffect } from 'react';
import './FavoriteStores.css';

const FavoriteStores = ({ onStoreSelect }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    const handleStorageChange = () => {
      const storedFavorites = JSON.parse(localStorage.getItem('favoriteStores') || '[]');
      setFavorites(storedFavorites);
    };

    // Initial load
    handleStorageChange();

    // Listen for changes
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const clearFavorites = (e) => {
    e.stopPropagation();
    localStorage.setItem('favoriteStores', '[]');
    setFavorites([]);
  };

  if (!favorites.length) {
    return null;
  }

  return (
    <div className="favorite-stores">
      <div 
        className="favorite-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="header-left">
          <h3>Favorite Stores</h3>
          <span className="store-count">
            {favorites.length} {favorites.length === 1 ? 'store' : 'stores'}
          </span>
        </div>
        <div className="header-right">
          <button 
            onClick={clearFavorites} 
            className="clear-favorites"
          >
            <i className="fas fa-trash-alt"></i>
            Clear
          </button>
          <i className={`fas fa-chevron-${isExpanded ? 'up' : 'down'} toggle-icon`}></i>
        </div>
      </div>
      
      {isExpanded && (
        <div className="favorites-grid">
          {favorites.map((storeUrl, index) => (
            <div 
              key={storeUrl + index}
              className="favorite-item"
              onClick={() => onStoreSelect(storeUrl)}
            >
              <div className="store-info">
                <span className="store-domain">
                  {new URL(storeUrl).hostname}
                </span>
                <i className="fas fa-star favorite-icon"></i>
              </div>
              <div className="store-url">
                {storeUrl}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FavoriteStores; 